import React from 'react'
import { CardInfo } from '../../../components/CardInfo'

const CompositionIgr = ({ t, composition }) => {
    return (
        <div className="composition">
            <div className="chart-row">
                <h3 className="chart-title">{t('one_pager_report.composition')}</h3>
                <div className="chart-content">
                    <CardInfo title={t('one_pager_report.projects')} data={composition?.projects ?? 0} />
                    <CardInfo title={t('one_pager_report.operations')} data={composition?.operations ?? 0} />
                    <CardInfo
                        title={t('one_pager_report.years')}
                        data={composition?.years ?? 0}
                        units={
                            (composition?.years ?? 0) > 1
                                ? t('one_pager_report.antiquity_years')
                                : t('one_pager_report.antiquity_year')
                        }
                    />
                </div>
            </div>
        </div>
    )
}

export default CompositionIgr